<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="productLabelLoaded" class="block-body riskometer" id="fund-riskometer">
      <h4 class="small-title">{{"products.overview-riskometer" | translate}}</h4>
      <div class="padding-box" [innerHTML]="productLabel">
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5 *ngIf="page && page.isPreview()">
    Fund Content Component - Risks/Product Label
  </h5>
</ng-template>
